import { AppCollectionDataTypes, FieldMap } from '@hb/shared'
import { insuranceProviderFields } from './insurer'
import { midwifeFields } from './practice'

export const appCollectionFields: Partial<Record<keyof AppCollectionDataTypes, FieldMap>> = {
  insurers: insuranceProviderFields,
  medicaidInsurers: insuranceProviderFields,
  practices: midwifeFields,
}
